import { createSlice } from "@reduxjs/toolkit";

const initalManagerState = {
  teamMemberPerformance: {
    data: [],
    streakData: [],
    loading: false,
  },
};

const manager = createSlice({
  name: "manager",
  initialState: initalManagerState,
  reducers: {
    getManagerPerformanceSaga(state) {
      state.teamMemberPerformance.loading = true;
    },
    getManagerPerformance(state, action) {
      state.teamMemberPerformance.data = action.payload?.data;
      state.teamMemberPerformance.loading = false;
      state.teamMemberPerformance.streakData = action.payload?.streakData;
    },
    getManagerPerformanceFail(state) {
      state.teamMemberPerformance.data = [];
      state.teamMemberPerformance.steakData = [];
      state.teamMemberPerformance.loading = false;
    },
  },
});
export const managerAction = manager.actions;
export default manager.reducer;
